import Vue from 'vue/dist/vue.min';

export function vm(){
    const v = new Vue({
        el: '#headapp',
		data: {
			flag: false
		},
    });
};